export const isFollowZoneEnabled = false;
export const isFeedbackButtonEnabled = true;

export const isMobileDownloadEnabled =
  process.env.REACT_APP_MOBILE_DOWNLOAD === 'true'; // Show mobile app download components
